import { apiClient } from '../api-client/apiClientService';

interface UserNameUpdate {
  firstName: string;
  lastName: string;
}

export interface UserProfile {
  userId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  createdAt: string;
  updatedAt: string;
}

class UserService {
  /**
   * Set the active project for the current user
   * @param projectId The project ID to set as active
   * @returns The response data
   */
  public async setActiveProject(projectId: string): Promise<any> {
    const response = await apiClient.post<any>(`user/set-active-project/${projectId}/`);
    return response.data;
  }

  /**
   * Set the active organization for the current user
   * @param organizationId The organization ID to set as active
   * @returns The response data
   */
  public async setActiveOrganization(organizationId: string): Promise<any> {
    const response = await apiClient.post<any>(`user/set-active-organization/${organizationId}/`);
    return response.data;
  }

  /**
   * Get the user's profile information
   * @returns The user profile data
   */
  public async getUserProfile(): Promise<UserProfile> {
    const response = await apiClient.get<any>(`user/`);

    // The API returns { status: "success", user: {...} }
    if (response.data && response.data.status === "success" && response.data.user) {
      return response.data.user;
    }

    return response.data;
  }

  /**
   * Update the user's name
   * @param firstName The user's first name
   * @param lastName The user's last name
   * @returns The response data
   */
  public async updateUserName(firstName: string, lastName: string): Promise<any> {
    const response = await apiClient.put<any>(`user/name/`, { firstName, lastName });
    return response.data;
  }
}

export const userService = new UserService();
